var landingPage = require('./form.ejs');
var landingPageRow = require('./row.ejs');

const form = { form: landingPage };
const row = { form: landingPageRow };

export { form, row };
export default { form };
